// import { useState } from 'react';
import TextField from '@mui/material/TextField';
import Container from '@mui/material/Container';
// import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { deepmerge } from '@mui/utils';
import PulseLoader from 'react-spinners/PulseLoader';
const themeOptions = {
  palette: {
    type: 'light',
    primary: {
      main: '#b71c1c',
    },
    secondary: {
      main: '#e0e0e0',
    },
    warning: {
      main: '#ff9100',
    },
  },
};

export default function EmailInput({
  email,
  button,
  setEmail,
  loading,
  buttonText,
  label,
  handleClick,
}) {
  let theme = createTheme(deepmerge(themeOptions));

  return (
    <ThemeProvider theme={theme}>
      <Container
        maxWidth="xs"
        sx={{ display: 'flex', flexDirection: 'column' }}
      >
        <TextField
          id="outlined-basic"
          label={label ? label : 'Customer Email'}
          variant="outlined"
          type={'email'}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          sx={{ m: '10px' }}
        />
        {button && (
          <Button variant="contained" color="error" onClick={handleClick}>
            {buttonText ? buttonText : 'Reset Password'}
            {loading && (
              <div style={{ marginTop: '5px', marginLeft: '10px' }}>
                <PulseLoader
                  size={10}
                  color={theme.palette.primary.contrastText}
                />
              </div>
            )}
          </Button>
        )}
      </Container>
    </ThemeProvider>
  );
}
